'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DoubleTriangle = function DoubleTriangle(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutProperties(_ref, ['fill']);

  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      'svg',
      { style: { display: 'block' }, xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', x: '0px', y: '0px', width: '100%', height: '100%', viewBox: '0 0 24 24' },
      _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('polygon', { fill: fill, points: '12,2 18,10 6,10' }),
        _react2.default.createElement('polygon', { fill: fill, points: '12,22 18,14 6,14' })
      )
    )
  );
};

DoubleTriangle.propTypes = _extends({}, _Icon2.default.propTypes);

DoubleTriangle.defaultProps = _extends({}, _Icon2.default.defaultProps);

exports.default = DoubleTriangle;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL0RvdWJsZVRyaWFuZ2xlLmpzIl0sIm5hbWVzIjpbIkRvdWJsZVRyaWFuZ2xlIiwiZmlsbCIsInByb3BzIiwiZGlzcGxheSIsInByb3BUeXBlcyIsImRlZmF1bHRQcm9wcyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFBQTs7OztBQUNBOzs7Ozs7OztBQUVBLElBQU1BLGlCQUFpQixTQUFqQkEsY0FBaUIsT0FBd0I7QUFBQSxNQUFyQkMsSUFBcUIsUUFBckJBLElBQXFCO0FBQUEsTUFBWkMsS0FBWTs7QUFDN0MsU0FDRTtBQUFBO0FBQVVBLFNBQVY7QUFDRTtBQUFBO0FBQUEsUUFBSyxPQUFPLEVBQUVDLFNBQVMsT0FBWCxFQUFaLEVBQWtDLE9BQU0sNEJBQXhDLEVBQXFFLFlBQVcsOEJBQWhGLEVBQStHLEdBQUUsS0FBakgsRUFBdUgsR0FBRSxLQUF6SCxFQUErSCxPQUFNLE1BQXJJLEVBQTRJLFFBQU8sTUFBbkosRUFBMEosU0FBUSxXQUFsSztBQUNFO0FBQUE7QUFBQTtBQUNFLG1EQUFTLE1BQU1GLElBQWYsRUFBcUIsUUFBTyxpQkFBNUIsR0FERjtBQUVFLG1EQUFTLE1BQU1BLElBQWYsRUFBcUIsUUFBTyxrQkFBNUI7QUFGRjtBQURGO0FBREYsR0FERjtBQVVELENBWEQ7O0FBYUFELGVBQWVJLFNBQWYsZ0JBQ0ssZUFBS0EsU0FEVjs7QUFJQUosZUFBZUssWUFBZixnQkFDSyxlQUFLQSxZQURWOztrQkFJZUwsYyIsImZpbGUiOiJEb3VibGVUcmlhbmdsZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBJY29uIGZyb20gJy4vSWNvbidcblxuY29uc3QgRG91YmxlVHJpYW5nbGUgPSAoeyBmaWxsLCAuLi5wcm9wcyB9KSA9PiB7XG4gIHJldHVybiAoXG4gICAgPEljb24gey4uLnByb3BzfT5cbiAgICAgIDxzdmcgc3R5bGU9e3sgZGlzcGxheTogJ2Jsb2NrJyB9fSB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHhtbG5zWGxpbms9J2h0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsnIHg9JzBweCcgeT0nMHB4JyB3aWR0aD0nMTAwJScgaGVpZ2h0PScxMDAlJyB2aWV3Qm94PScwIDAgMjQgMjQnPlxuICAgICAgICA8Zz5cbiAgICAgICAgICA8cG9seWdvbiBmaWxsPXtmaWxsfSBwb2ludHM9JzEyLDIgMTgsMTAgNiwxMCcgLz5cbiAgICAgICAgICA8cG9seWdvbiBmaWxsPXtmaWxsfSBwb2ludHM9JzEyLDIyIDE4LDE0IDYsMTQnIC8+XG4gICAgICAgIDwvZz5cbiAgICAgIDwvc3ZnPlxuICAgIDwvSWNvbj5cbiAgKVxufVxuXG5Eb3VibGVUcmlhbmdsZS5wcm9wVHlwZXMgPSB7XG4gIC4uLkljb24ucHJvcFR5cGVzXG59XG5cbkRvdWJsZVRyaWFuZ2xlLmRlZmF1bHRQcm9wcyA9IHtcbiAgLi4uSWNvbi5kZWZhdWx0UHJvcHNcbn1cblxuZXhwb3J0IGRlZmF1bHQgRG91YmxlVHJpYW5nbGVcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/DoubleTriangle.js
// module id = 580
// module chunks = 0